import * as Dialog from '@radix-ui/react-dialog';
import type { HTMLAttributes, RefObject } from 'react';

import {
  CONTENT_CLASS,
  OVERLAY_CLASS,
} from '~/components/ModalDialog/components/styles';
import { ModalDialog } from '~/components/ModalDialog/ModalDialog';
import { renderSlot } from '~/components/ModalDialog/utils/renderSlot';
import { cn } from '~/lib/cn';

interface ModalDialogContentProps extends HTMLAttributes<HTMLDivElement> {
  overlayRef?: RefObject<HTMLDivElement>;
  contentRef?: RefObject<HTMLDivElement>;
}

export function ModalDialogContent({
  overlayRef,
  contentRef,
  children,
  ...props
}: ModalDialogContentProps) {
  return (
    <Dialog.Portal>
      <Dialog.Overlay
        ref={overlayRef}
        className={cn(
          'pointer-events-none fixed inset-0 z-40 bg-overlay',
          OVERLAY_CLASS.show,
        )}
      />
      <Dialog.Content
        {...props}
        ref={contentRef}
        className={cn(
          'fixed z-50 flex flex-col overflow-hidden text-default',
          'left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 transform',
          'max-h-[calc(100vh-20px)] min-w-[420px] max-w-[min(100vw,680px)]',
          'rounded-sm border-px shadow-xl drop-shadow-xl bg-level-02 border-emphasis-subtle',
          CONTENT_CLASS.show,
          props.className,
        )}
      >
        {renderSlot(ModalDialog.Header, children)}
        {renderSlot(ModalDialog.Body, children)}
        {renderSlot(ModalDialog.Footer, children)}
      </Dialog.Content>
    </Dialog.Portal>
  );
}

ModalDialogContent.displayName = 'ModalDialogContent';
